import {AccordionData} from "../../interfaces/AccordionData";
import AccordionWrapper from "./AccordionWrapper";
import AccordionDetailsInfo from "./AccordionDetailsInfo";
import React from "react";

export function InfoAccordion(props: { title: string, data: AccordionData[] }) {
    return <AccordionWrapper title={props.title}><AccordionDetailsInfo data={props.data}/></AccordionWrapper>;
}